// extracted by mini-css-extract-plugin
export default {"linkElement":"LinkElement_linkElement__JgJdm","label":"LinkElement_label__TcGp7","icon":"LinkElement_icon__5qM62","red":"LinkElement_red__LUGwZ","blue":"LinkElement_blue__eKAXD"};